
export class Task {
    id                : number;
    title             : string;
    date_due          : string;
    created_by        : number;
    assigned_to       : number;
    percent_done      : string;
    task_category_id  : number;
    status_id         : number;
    report_id         : number;
    incident_id       : number;
    repair_request_id : number;
    ticket_id         : number;
    ca_report_id      : number;
    is_urgent         : number;
    file              : string;
    notes             : string;
 }
 